import { createTheme } from "@mui/material/styles";
import {
  brandOrange,
  brandDark,
  white,
  text,
  link,
  linkActive,
  linkHover,
  lightHover,
  darkHover,
} from "./components/Colors";

const theme = createTheme({
  palette: {
    primary: {
      main: brandOrange,
      dark: darkHover,
      light: brandOrange,
      contrastText: white,
    },
    secondary: {
      main: link,
      dark: darkHover,
      light: lightHover,
      contrastText: white,
    },
    background: {
      default: white,
      paper: white,
    },
    text: {
      primary: text,
      secondary: brandDark,
    },
    action: {
      active: linkActive,
      hover: linkHover,
      hoverOpacity: 0.08,
    },
  },
  typography: {
    fontFamily: '"PT Sans", sans-serif',
    h1: {
      fontFamily: '"Inria Sans"',
      fontWeight: 700,
      lineHeight: 1,
      fontSize: "36px",
      "@media (min-width:600px)": {
        fontSize: "45px",
      },
      "@media (min-width:960px)": {
        fontSize: "75px",
      },
    },
    h2: {
      fontFamily: '"Inria Sans"',
      fontWeight: 700,
      lineHeight: 1,
      fontSize: "35px",
    },
    h3: {
      fontFamily: '"Inria Sans"',
      fontWeight: 700,
      lineHeight: 1,
      fontSize: "29px",
    },
    h4: {
      fontFamily: '"Inria Sans"',
      fontWeight: 700,
      lineHeight: 1,
      fontSize: "23px",
    },
    h5: {
      fontFamily: '"Inria Sans"',
      fontWeight: 700,
      lineHeight: 1,
      fontSize: "18px",
    },
    body1: {
      fontFamily: '"PT Sans", sans-serif',
      lineHeight: 1.44,
      fontSize: "18px",
    },
    body2: {
      fontFamily: '"PT Sans", sans-serif',
      lineHeight: 1.44,
      fontSize: "16px",
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          fontFamily: '"PT Sans", sans-serif',
        },
        contained: {
          backgroundColor: brandOrange,
          color: white,
          "&:hover": {
            backgroundColor: brandDark,
          },
        },
      },
    },
    MuiLink: {
      styleOverrides: {
        root: {
          color: link,
          "&:hover": {
            color: darkHover,
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-root": {
            "&.Mui-focused fieldset": {
              borderColor: darkHover,
            },
          },
          "& .MuiInputLabel-root.Mui-focused": {
            color: darkHover,
          },
        },
      },
    },
    MuiCircularProgress: {
      styleOverrides: {
        root: {
          color: brandOrange,
        },
      },
    },
    MuiLinearProgress: {
      styleOverrides: {
        root: {
          backgroundColor: lightHover,
        },
        bar: {
          backgroundColor: brandOrange,
        },
      },
    },
  },
});

export default theme;
